/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} History_Transfer_ImportingInputs */

const en_us2_history_transfer_importing = /** @type {(inputs: History_Transfer_ImportingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importing… ${i?.done} of ${i?.total}`)
};

const pt_br2_history_transfer_importing = /** @type {(inputs: History_Transfer_ImportingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importando… ${i?.done} de ${i?.total}`)
};

const es_419_history_transfer_importing = /** @type {(inputs: History_Transfer_ImportingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importando… ${i?.done} de ${i?.total}`)
};

const pt_pt2_history_transfer_importing = /** @type {(inputs: History_Transfer_ImportingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A importar… ${i?.done} de ${i?.total}`)
};

const fr_fr2_history_transfer_importing = /** @type {(inputs: History_Transfer_ImportingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Import… ${i?.done} sur ${i?.total}`)
};

const de_de2_history_transfer_importing = /** @type {(inputs: History_Transfer_ImportingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Import läuft… ${i?.done} von ${i?.total}`)
};

const it_it2_history_transfer_importing = /** @type {(inputs: History_Transfer_ImportingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importazione… ${i?.done} di ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Importing… {done} of {total}" |
*
* @param {History_Transfer_ImportingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_importing = /** @type {((inputs: History_Transfer_ImportingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_ImportingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_importing(inputs)
	if (locale === "es-419") return es_419_history_transfer_importing(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_importing(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_importing(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_importing(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_importing(inputs)
	return en_us2_history_transfer_importing(inputs)
});
export { history_transfer_importing as "history-transfer.importing" }